<script>
import Title from "@/components/admin/common/TitleArea.vue"
import PageGuideDialog from "@/components/admin/fulfillment/guide/PageGuideDialog.vue"
import FulfillmentPageGuide from "@/components/admin/fulfillment/guide/FulfillmentPageGuide.vue"

const emptyForm = () => ({
  id: null,
  matchType: 'keyword',
  matchValue: '',
  hsCode: '',
  description: '',
  priority: 100,
  isActive: true
})

export default {
  name: 'AdminHsCodeManage',
  components: {
    Title,
    PageGuideDialog,
    FulfillmentPageGuide
  },
  data() {
    return {
      description: {
        title: 'HS CODE 관리'
      },
      activeTab: 'mappings',
      rows: [],
      candidateRows: [],
      loading: false,
      candidateLoading: false,
      extractingCandidates: false,
      saving: false,
      guideDialog: false,
      message: '',
      testItemName: '',
      testResult: null,
      candidateSummary: {
        pending: 0,
        needsReview: 0,
        mapped: 0,
        ignored: 0,
        lastRun: null
      },
      filters: {
        q: '',
        matchType: '',
        isActive: ''
      },
      candidateFilters: {
        q: '',
        status: 'pending'
      },
      form: emptyForm(),
      matchTypeOptions: [
        { label: '전체', value: '' },
        { label: '정확히 일치', value: 'exact' },
        { label: '키워드 포함', value: 'keyword' }
      ],
      formMatchTypeOptions: [
        { label: '정확히 일치', value: 'exact' },
        { label: '키워드 포함', value: 'keyword' }
      ],
      activeOptions: [
        { label: '전체', value: '' },
        { label: '활성', value: '1' },
        { label: '비활성', value: '0' }
      ],
      candidateStatusOptions: [
        { label: '전체', value: '' },
        { label: '검토 대기', value: 'pending' },
        { label: '검수 필요', value: 'needs_review' },
        { label: '등록 완료', value: 'mapped' },
        { label: '제외', value: 'ignored' }
      ],
      columns: [
        { name: 'id', label: 'ID', field: 'id', align: 'center' },
        { name: 'matchType', label: '매칭방식', field: 'matchType', align: 'center' },
        { name: 'matchValue', label: '매칭값', field: 'matchValue', align: 'left' },
        { name: 'hsCode', label: 'HS CODE', field: 'hsCode', align: 'center' },
        { name: 'description', label: '설명', field: 'description', align: 'left' },
        { name: 'priority', label: '우선순위', field: 'priority', align: 'center' },
        { name: 'isActive', label: '상태', field: 'isActive', align: 'center' },
        { name: 'updatedAt', label: '수정일', field: 'updatedAt', align: 'left' },
        { name: 'actions', label: '관리', field: 'actions', align: 'center' }
      ],
      candidateColumns: [
        { name: 'sourceItemName', label: '원본 상품명', field: 'sourceItemName', align: 'left' },
        { name: 'normalizedItemName', label: '대표 키워드', field: 'normalizedItemName', align: 'left' },
        { name: 'orderCount', label: '사용 건수', field: 'orderCount', align: 'center' },
        { name: 'orderBaseCount', label: '오더 수', field: 'orderBaseCount', align: 'center' },
        { name: 'description', label: '근거', field: 'description', align: 'left' },
        { name: 'status', label: '상태', field: 'status', align: 'center' },
        { name: 'lastSeenAt', label: '최근 사용일', field: 'lastSeenAt', align: 'left' },
        { name: 'actions', label: '관리', field: 'actions', align: 'center' }
      ]
    }
  },
  computed: {
    isEditing() {
      return !!this.form.id
    }
  },
  methods: {
    getMatchTypeLabel(type) {
      if (type === 'exact') return '정확히 일치'
      if (type === 'keyword') return '키워드 포함'
      return type || '-'
    },
    buildQuery() {
      return new URLSearchParams({
        q: this.filters.q || '',
        matchType: this.filters.matchType || '',
        isActive: this.filters.isActive || ''
      }).toString()
    },
    buildCandidateQuery() {
      return new URLSearchParams({
        q: this.candidateFilters.q || '',
        status: this.candidateFilters.status || ''
      }).toString()
    },
    getCandidateStatusLabel(status) {
      const found = this.candidateStatusOptions.find(option => option.value === status)
      return found?.label || status || '-'
    },
    getCandidateStatusColor(status) {
      if (status === 'pending') return 'warning'
      if (status === 'needs_review') return 'deep-orange'
      if (status === 'mapped') return 'positive'
      if (status === 'ignored') return 'grey-6'
      return 'grey-6'
    },
    parseCandidateEvidence(description) {
      return String(description || '')
        .split(' / ')
        .map(part => part.trim())
        .filter(Boolean)
    },
    normalizeHsCodeInput() {
      this.form.hsCode = String(this.form.hsCode || '').replace(/\D/g, '').slice(0, 6)
    },
    resetForm() {
      this.form = emptyForm()
      this.message = ''
    },
    editRow(row) {
      this.activeTab = 'mappings'
      this.form = {
        id: row.id,
        matchType: row.matchType,
        matchValue: row.matchValue,
        hsCode: row.hsCode,
        description: row.description || '',
        priority: Number(row.priority || 100),
        isActive: Number(row.isActive) === 1
      }
      this.message = `ID ${row.id} 수정 중입니다.`
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    },
    testWithSuggestion(suggestion) {
      this.testItemName = suggestion.matchValue || ''
      this.testResolve()
    },
    async loadList() {
      this.loading = true
      try {
        const res = await this.$http({
          method: 'GET',
          url: `/api/parcel/hs-code-mappings?${this.buildQuery()}`,
          name: '[ Axios / HS CODE 관리 / 목록 조회 ]'
        })
        this.rows = Array.isArray(res.data?.data) ? res.data.data : []
      } catch (error) {
        this.rows = []
        this.$q.notify({ type: 'negative', message: error?.response?.data?.message || 'HS CODE 목록 조회에 실패했습니다.' })
      } finally {
        this.loading = false
      }
    },
    async refreshActiveTab() {
      if (this.activeTab === 'candidates') {
        await this.refreshCandidates()
        return
      }
      if (this.activeTab === 'test' && this.testItemName) {
        await this.testResolve()
        return
      }
      await this.loadList()
    },
    async loadCandidateSummary() {
      try {
        const res = await this.$http({
          method: 'GET',
          url: '/api/parcel/hs-code-candidates/summary',
          name: '[ Axios / HS CODE 후보 / 요약 조회 ]'
        })
        this.candidateSummary = res.data?.data || this.candidateSummary
      } catch (error) {
        this.$q.notify({ type: 'negative', message: error?.response?.data?.message || 'HS CODE 후보 요약 조회에 실패했습니다.' })
      }
    },
    async loadCandidates() {
      this.candidateLoading = true
      try {
        const res = await this.$http({
          method: 'GET',
          url: `/api/parcel/hs-code-candidates?${this.buildCandidateQuery()}`,
          name: '[ Axios / HS CODE 후보 / 목록 조회 ]'
        })
        this.candidateRows = Array.isArray(res.data?.data) ? res.data.data : []
      } catch (error) {
        this.candidateRows = []
        this.$q.notify({ type: 'negative', message: error?.response?.data?.message || 'HS CODE 후보 목록 조회에 실패했습니다.' })
      } finally {
        this.candidateLoading = false
      }
    },
    async refreshCandidates() {
      await Promise.all([this.loadCandidateSummary(), this.loadCandidates()])
    },
    async extractCandidates() {
      if (!window.confirm('과거 ITEM 데이터 기준으로 HS CODE 매핑 후보를 다시 추출하시겠습니까?')) return
      this.extractingCandidates = true
      try {
        const res = await this.$http({
          method: 'POST',
          url: '/api/parcel/hs-code-candidates/extract',
          data: {},
          name: '[ Axios / HS CODE 후보 / 수동 추출 ]'
        })
        const result = res.data?.data || {}
        this.$q.notify({
          type: 'positive',
          message: `후보 추출 완료: 신규 ${result.createdCount || 0}건, 갱신 ${result.updatedCount || 0}건`
        })
        await this.refreshCandidates()
      } catch (error) {
        this.$q.notify({ type: 'negative', message: error?.response?.data?.message || 'HS CODE 후보 추출에 실패했습니다.' })
      } finally {
        this.extractingCandidates = false
      }
    },
    applyCandidateToForm(row) {
      this.activeTab = 'mappings'
      this.form = {
        id: null,
        matchType: row.suggestedMatchType || 'keyword',
        matchValue: row.normalizedItemName || row.sourceItemName || '',
        hsCode: row.suggestedHsCode || '',
        description: row.description || '',
        priority: 50,
        isActive: true
      }
      this.message = `후보 ID ${row.id} 기준으로 매핑 등록 준비 중입니다. HS CODE 입력 후 등록하세요.`
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    },
    async mapCandidate(row) {
      const hsCode = window.prompt(`${row.normalizedItemName}에 등록할 HS CODE 6자리를 입력하세요.`, row.suggestedHsCode || '')
      if (hsCode === null) return
      const normalizedHsCode = String(hsCode || '').replace(/\D/g, '').slice(0, 6)
      if (!/^\d{6}$/.test(normalizedHsCode)) {
        this.$q.notify({ type: 'negative', message: 'HS CODE는 숫자 6자리여야 합니다.' })
        return
      }

      try {
        await this.$http({
          method: 'POST',
          url: `/api/parcel/hs-code-candidates/${row.id}/map`,
          data: {
            matchType: row.suggestedMatchType || 'keyword',
            matchValue: row.normalizedItemName,
            hsCode: normalizedHsCode,
            description: row.description || `후보에서 등록: ${row.sourceItemName}`,
            priority: 50
          },
          name: '[ Axios / HS CODE 후보 / 매핑 반영 ]'
        })
        this.$q.notify({ type: 'positive', message: '후보가 HS CODE 매핑에 등록되었습니다.' })
        await Promise.all([this.refreshCandidates(), this.loadList()])
      } catch (error) {
        this.$q.notify({ type: 'negative', message: error?.response?.data?.message || 'HS CODE 후보 매핑 등록에 실패했습니다.' })
      }
    },
    async ignoreCandidate(row) {
      const reason = window.prompt('제외 사유를 입력하세요.', row.reason || '관리자 제외')
      if (reason === null) return
      try {
        await this.$http({
          method: 'PATCH',
          url: `/api/parcel/hs-code-candidates/${row.id}/ignore`,
          data: { reason },
          name: '[ Axios / HS CODE 후보 / 제외 ]'
        })
        this.$q.notify({ type: 'positive', message: '후보가 제외 처리되었습니다.' })
        await this.refreshCandidates()
      } catch (error) {
        this.$q.notify({ type: 'negative', message: error?.response?.data?.message || 'HS CODE 후보 제외에 실패했습니다.' })
      }
    },
    async restoreCandidate(row) {
      if (!window.confirm(`"${row.normalizedItemName}" 후보의 제외 상태를 해제하시겠습니까?`)) return
      try {
        await this.$http({
          method: 'PATCH',
          url: `/api/parcel/hs-code-candidates/${row.id}/restore`,
          name: '[ Axios / HS CODE 후보 / 제외 해제 ]'
        })
        this.$q.notify({ type: 'positive', message: '후보 제외가 해제되었습니다.' })
        await this.refreshCandidates()
      } catch (error) {
        this.$q.notify({ type: 'negative', message: error?.response?.data?.message || 'HS CODE 후보 제외 해제에 실패했습니다.' })
      }
    },
    validateForm() {
      if (!this.form.matchValue) return '매칭값을 입력해주세요.'
      if (!/^\d{6}$/.test(String(this.form.hsCode || ''))) return 'HS CODE는 숫자 6자리여야 합니다.'
      if (!Number.isFinite(Number(this.form.priority))) return '우선순위는 숫자여야 합니다.'
      return ''
    },
    async saveMapping() {
      const errorMessage = this.validateForm()
      if (errorMessage) {
        this.$q.notify({ type: 'negative', message: errorMessage })
        return
      }

      this.saving = true
      const payload = {
        ...this.form,
        isActive: this.form.isActive ? 1 : 0
      }
      try {
        await this.$http({
          method: this.isEditing ? 'PUT' : 'POST',
          url: this.isEditing ? `/api/parcel/hs-code-mappings/${this.form.id}` : '/api/parcel/hs-code-mappings',
          data: payload,
          name: '[ Axios / HS CODE 관리 / 저장 ]'
        })
        this.$q.notify({ type: 'positive', message: this.isEditing ? 'HS CODE 매핑이 수정되었습니다.' : 'HS CODE 매핑이 등록되었습니다.' })
        this.resetForm()
        this.loadList()
      } catch (error) {
        this.$q.notify({ type: 'negative', message: error?.response?.data?.message || 'HS CODE 매핑 저장에 실패했습니다.' })
      } finally {
        this.saving = false
      }
    },
    async deactivate(row) {
      if (!window.confirm(`ID ${row.id} 매핑을 비활성화하시겠습니까?`)) return
      try {
        await this.$http({
          method: 'PATCH',
          url: `/api/parcel/hs-code-mappings/${row.id}/deactivate`,
          name: '[ Axios / HS CODE 관리 / 비활성화 ]'
        })
        this.$q.notify({ type: 'positive', message: 'HS CODE 매핑이 비활성화되었습니다.' })
        if (this.form.id === row.id) this.resetForm()
        this.loadList()
      } catch (error) {
        this.$q.notify({ type: 'negative', message: error?.response?.data?.message || 'HS CODE 매핑 비활성화에 실패했습니다.' })
      }
    },
    async testResolve() {
      const itemName = String(this.testItemName || '').trim()
      if (!itemName) {
        this.$q.notify({ type: 'warning', message: '테스트할 상품명을 입력해주세요.' })
        return
      }

      try {
        const res = await this.$http({
          method: 'POST',
          url: '/api/parcel/resolveHsCode',
          data: { itemName },
          name: '[ Axios / HS CODE 관리 / 매칭 테스트 ]'
        })
        this.testResult = res.data
      } catch (error) {
        this.testResult = null
        this.$q.notify({ type: 'negative', message: error?.response?.data?.message || 'HS CODE 매칭 테스트에 실패했습니다.' })
      }
    }
  },
  mounted() {
    if (this.$route?.query?.tab === 'candidates') {
      this.activeTab = 'candidates'
    }
    this.loadList()
    this.loadCandidateSummary()
    this.loadCandidates()
  }
}
</script>

<template>
  <q-page class="q-pa-lg">
    <div class="row q-mb-lg">
      <div class="col">
        <Title :desc="description">
          <template #title-action>
            <q-btn
              flat
              round
              dense
              size="sm"
              color="primary"
              icon="help_outline"
              aria-label="HS CODE 관리 사용 가이드"
              @click="guideDialog = true">
              <q-tooltip>HS CODE 관리 사용 가이드</q-tooltip>
            </q-btn>
          </template>
          <q-btn
            flat
            round
            dense
            icon="refresh"
            color="primary"
            @click="refreshActiveTab">
            <q-tooltip>새로고침</q-tooltip>
          </q-btn>
        </Title>
      </div>
    </div>

    <div class="comp-box q-mb-md">
      <q-tabs
        v-model="activeTab"
        align="left"
        active-color="primary"
        indicator-color="primary"
        class="hs-code-tabs">
        <q-tab name="mappings" icon="rule" label="매핑 목록" />
        <q-tab name="candidates" icon="manage_search" label="매핑 후보">
          <q-badge
            v-if="candidateSummary.pending || candidateSummary.needsReview"
            color="negative"
            floating>
            {{ candidateSummary.pending + candidateSummary.needsReview }}
          </q-badge>
        </q-tab>
        <q-tab name="test" icon="science" label="매칭 테스트" />
      </q-tabs>
    </div>

    <q-tab-panels
      v-model="activeTab"
      animated
      class="bg-transparent">
      <q-tab-panel name="mappings" class="q-pa-none">
        <div class="comp-box q-mb-md">
          <div class="text-subtitle1 text-weight-bold q-mb-md">
            매핑 기준 등록
          </div>
          <div class="row q-col-gutter-md">
            <div class="col-12 col-md-4">
              <q-select
                v-model="form.matchType"
                :options="formMatchTypeOptions"
                emit-value
                map-options
                outlined
                dense
                label="매칭방식" />
            </div>
            <div class="col-12 col-md-8">
              <q-input
                v-model.trim="form.matchValue"
                outlined
                dense
                label="매칭값"
                placeholder="상품명에 적용할 기준값" />
            </div>
            <div class="col-12 col-md-4">
              <q-input
                v-model="form.hsCode"
                outlined
                dense
                maxlength="6"
                label="HS CODE"
                @update:model-value="normalizeHsCodeInput" />
            </div>
            <div class="col-12 col-md-4">
              <q-input
                v-model.number="form.priority"
                outlined
                dense
                type="number"
                label="우선순위" />
            </div>
            <div class="col-12 col-md-4">
              <q-toggle
                v-model="form.isActive"
                label="활성"
                color="primary" />
            </div>
            <div class="col-12">
              <q-input
                v-model.trim="form.description"
                outlined
                dense
                label="설명"
                placeholder="운영자가 이해할 수 있는 기준 설명" />
            </div>
          </div>
          <div class="row q-gutter-sm q-mt-md">
            <q-btn
              color="primary"
              unelevated
              :loading="saving"
              :label="isEditing ? '수정하기' : '등록하기'"
              @click="saveMapping" />
            <q-btn
              flat
              color="grey-7"
              label="초기화"
              @click="resetForm" />
            <div v-if="message" class="text-caption text-grey-7 self-center">
              {{ message }}
            </div>
          </div>
        </div>

        <div class="comp-box q-mb-md">
          <div class="row q-col-gutter-md items-end">
            <div class="col-12 col-md-5">
              <q-input
                v-model.trim="filters.q"
                outlined
                dense
                label="검색"
                placeholder="매칭값, HS CODE, 설명"
                @keyup.enter="loadList" />
            </div>
            <div class="col-12 col-md-3">
              <q-select
                v-model="filters.matchType"
                :options="matchTypeOptions"
                emit-value
                map-options
                outlined
                dense
                label="매칭방식" />
            </div>
            <div class="col-12 col-md-2">
              <q-select
                v-model="filters.isActive"
                :options="activeOptions"
                emit-value
                map-options
                outlined
                dense
                label="상태" />
            </div>
            <div class="col-12 col-md-2">
              <q-btn
                color="primary"
                unelevated
                class="full-width"
                label="조회"
                @click="loadList" />
            </div>
          </div>
        </div>

        <div class="comp-box">
          <q-table
            flat
            bordered
            row-key="id"
            :rows="rows"
            :columns="columns"
            :loading="loading"
            :rows-per-page-options="[20, 50, 100, 0]">
            <template #body-cell-matchType="props">
              <q-td :props="props">
                {{ getMatchTypeLabel(props.row.matchType) }}
              </q-td>
            </template>

            <template #body-cell-isActive="props">
              <q-td :props="props">
                <q-badge :color="Number(props.row.isActive) === 1 ? 'positive' : 'grey-6'">
                  {{ Number(props.row.isActive) === 1 ? '활성' : '비활성' }}
                </q-badge>
              </q-td>
            </template>

            <template #body-cell-actions="props">
              <q-td :props="props">
                <div class="row q-gutter-sm justify-center">
                  <q-btn
                    flat
                    dense
                    size="sm"
                    color="primary"
                    label="수정"
                    @click="editRow(props.row)" />
                  <q-btn
                    flat
                    dense
                    size="sm"
                    color="negative"
                    label="비활성"
                    :disable="Number(props.row.isActive) !== 1"
                    @click="deactivate(props.row)" />
                </div>
              </q-td>
            </template>

            <template #no-data>
              <div class="full-width text-center text-grey-6 q-pa-lg">
                등록된 HS CODE 매핑 기준이 없습니다.
              </div>
            </template>
          </q-table>
        </div>
      </q-tab-panel>

      <q-tab-panel name="candidates" class="q-pa-none">
        <div class="comp-box q-mb-md">
          <div class="row items-center justify-between q-col-gutter-md q-mb-md">
            <div class="col-12 col-md">
              <div class="text-subtitle1 text-weight-bold">
                HS CODE 매핑 후보
              </div>
              <div class="text-caption text-grey-7">
                과거 오더 상품명에서 자주 사용됐지만 아직 매핑되지 않은 항목을 검토합니다.
              </div>
            </div>
            <div class="col-12 col-md-auto row q-gutter-sm">
              <q-btn
                color="primary"
                unelevated
                icon="manage_search"
                :loading="extractingCandidates"
                label="후보 추출"
                @click="extractCandidates" />
              <q-btn
                flat
                color="primary"
                icon="refresh"
                label="새로고침"
                @click="refreshCandidates" />
            </div>
          </div>

          <div class="row q-col-gutter-md q-mb-md">
            <div class="col-6 col-md-3">
              <q-card flat bordered class="q-pa-md candidate-summary-card">
                <div class="text-caption text-grey-7">검토 대기</div>
                <div class="text-h5 text-weight-bold">{{ candidateSummary.pending }}</div>
              </q-card>
            </div>
            <div class="col-6 col-md-3">
              <q-card flat bordered class="q-pa-md candidate-summary-card">
                <div class="text-caption text-grey-7">검수 필요</div>
                <div class="text-h5 text-weight-bold text-deep-orange">{{ candidateSummary.needsReview }}</div>
              </q-card>
            </div>
            <div class="col-6 col-md-3">
              <q-card flat bordered class="q-pa-md candidate-summary-card">
                <div class="text-caption text-grey-7">등록 완료</div>
                <div class="text-h5 text-weight-bold text-positive">{{ candidateSummary.mapped }}</div>
              </q-card>
            </div>
            <div class="col-6 col-md-3">
              <q-card flat bordered class="q-pa-md candidate-summary-card">
                <div class="text-caption text-grey-7">마지막 실행</div>
                <div class="text-body2 text-weight-bold">
                  {{ candidateSummary.lastRun?.finishedAt || '-' }}
                </div>
              </q-card>
            </div>
          </div>

          <div class="row q-col-gutter-md items-end q-mb-md">
            <div class="col-12 col-md-5">
              <q-input
                v-model.trim="candidateFilters.q"
                outlined
                dense
                label="후보 검색"
                placeholder="원본 상품명, 대표 키워드, 설명"
                @keyup.enter="loadCandidates" />
            </div>
            <div class="col-12 col-md-3">
              <q-select
                v-model="candidateFilters.status"
                :options="candidateStatusOptions"
                emit-value
                map-options
                outlined
                dense
                label="후보 상태" />
            </div>
            <div class="col-12 col-md-2">
              <q-btn
                color="primary"
                unelevated
                class="full-width"
                label="조회"
                @click="loadCandidates" />
            </div>
          </div>

          <q-table
            flat
            bordered
            row-key="id"
            :rows="candidateRows"
            :columns="candidateColumns"
            :loading="candidateLoading"
            :rows-per-page-options="[10, 20, 50, 0]">
            <template #body-cell-status="props">
              <q-td :props="props">
                <q-badge :color="getCandidateStatusColor(props.row.status)">
                  {{ getCandidateStatusLabel(props.row.status) }}
                </q-badge>
                <div v-if="props.row.reason" class="text-caption text-grey-7 q-mt-xs">
                  {{ props.row.reason }}
                </div>
              </q-td>
            </template>

            <template #body-cell-description="props">
              <q-td :props="props">
                <div class="row q-gutter-xs">
                  <q-badge
                    v-for="item in parseCandidateEvidence(props.row.description)"
                    :key="`${props.row.id}-${item}`"
                    outline
                    color="grey-7">
                    {{ item }}
                  </q-badge>
                </div>
              </q-td>
            </template>

            <template #body-cell-actions="props">
              <q-td :props="props">
                <div class="row q-gutter-sm justify-center">
                  <q-btn
                    flat
                    dense
                    size="sm"
                    color="primary"
                    label="폼에 반영"
                    :disable="props.row.status === 'mapped' || props.row.status === 'ignored'"
                    @click="applyCandidateToForm(props.row)" />
                  <q-btn
                    flat
                    dense
                    size="sm"
                    color="positive"
                    label="등록"
                    :disable="props.row.status === 'mapped' || props.row.status === 'ignored'"
                    @click="mapCandidate(props.row)" />
                  <q-btn
                    flat
                    dense
                    size="sm"
                    color="negative"
                    label="제외"
                    :disable="props.row.status === 'mapped' || props.row.status === 'ignored'"
                    @click="ignoreCandidate(props.row)" />
                  <q-btn
                    v-if="props.row.status === 'ignored'"
                    flat
                    dense
                    size="sm"
                    color="primary"
                    label="제외 해제"
                    @click="restoreCandidate(props.row)" />
                </div>
              </q-td>
            </template>

            <template #no-data>
              <div class="full-width text-center text-grey-6 q-pa-lg">
                검토할 HS CODE 매핑 후보가 없습니다.
              </div>
            </template>
          </q-table>
        </div>
      </q-tab-panel>

      <q-tab-panel name="test" class="q-pa-none">
        <div class="comp-box">
          <div class="text-subtitle1 text-weight-bold q-mb-sm">
            매칭 테스트
          </div>
          <div class="text-caption text-grey-7 q-mb-md">
            상품명을 입력하면 실제 오더 등록과 같은 기준으로 HS CODE를 조회합니다.
          </div>
          <div class="row q-col-gutter-sm">
            <div class="col">
              <q-input
                v-model.trim="testItemName"
                outlined
                dense
                label="상품명"
                @keyup.enter="testResolve" />
            </div>
            <div class="col-auto">
              <q-btn
                color="primary"
                unelevated
                label="테스트"
                @click="testResolve" />
            </div>
          </div>
          <q-separator class="q-my-md" />
          <div v-if="testResult">
            <q-badge :color="testResult.matched ? 'positive' : 'grey-6'">
              {{ testResult.matched ? '매칭됨' : '미매칭' }}
            </q-badge>
            <div class="q-mt-sm">
              <div>HS CODE: <strong>{{ testResult.hsCode || '-' }}</strong></div>
              <div>출처: {{ testResult.source || '-' }}</div>
              <div>매칭값: {{ testResult.matchValue || '-' }}</div>
            </div>
            <div v-if="!testResult.matched && testResult.suggestions?.length" class="q-mt-md">
              <div class="text-caption text-grey-7 q-mb-sm">
                혹시 아래 기준을 찾으셨나요?
              </div>
              <div class="column q-gutter-sm">
                <q-card
                  v-for="suggestion in testResult.suggestions"
                  :key="`${suggestion.matchType}-${suggestion.matchValue}-${suggestion.hsCode}`"
                  flat
                  bordered
                  class="q-pa-sm suggestion-card"
                  @click="testWithSuggestion(suggestion)">
                  <div class="row items-center justify-between q-gutter-sm">
                    <div>
                      <div class="text-weight-bold">{{ suggestion.matchValue }}</div>
                      <div class="text-caption text-grey-7">
                        {{ getMatchTypeLabel(suggestion.matchType) }} · HS {{ suggestion.hsCode }} · 차이 {{ suggestion.distance }}
                      </div>
                    </div>
                    <q-btn
                      flat
                      dense
                      color="primary"
                      label="이 기준으로 테스트"
                      @click.stop="testWithSuggestion(suggestion)" />
                  </div>
                </q-card>
              </div>
            </div>
          </div>
          <div v-else class="text-grey-6">
            테스트 결과가 없습니다.
          </div>
        </div>
      </q-tab-panel>
    </q-tab-panels>

    <PageGuideDialog
      v-model="guideDialog"
      title="HS CODE 관리 사용 가이드"
      description="오더 등록 시 HS CODE 자동입력 기준을 관리하는 방법입니다."
    >
      <FulfillmentPageGuide guide-key="hsCodeManage" />
    </PageGuideDialog>
  </q-page>
</template>

<style scoped>
.suggestion-card {
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.suggestion-card:hover {
  border-color: #1976d2;
  background: #f7fbff;
}

.candidate-summary-card {
  min-height: 84px;
}
</style>
